import React, { useEffect } from "react";
import "./assets/css/bootstrap.min.css";
import "./assets/css/app.min.css";
import "./assets/css/custom.css";
import "./assets/css/wysiwyg.css";
import "./assets/css/responsive.css";
import { BrowserRouter as Router, Switch } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./store/store";
import Login from "./containers/login/Login";
import { loadUser } from "./store/actions/auth";
import BeforeLoginRoutes from "./shared/Routes/BeforeLoginRoutes";
import PrivateRoutes from "./shared/Routes/PrivateRoutes";
import Dashboard from "./containers/dashboard/Dashboard";
import AddBlog from "./containers/blogs/AddBlog";
import AllBlogs from "./containers/blogs/AllBlogs";
import ViewBlog from "./containers/blogs/ViewBlog";
import EditBlog from "./containers/blogs/EditBlog";
import AddPage from "./containers/pages/AddPage";
import AllPages from "./containers/pages/AllPages";
import ViewPage from "./containers/pages/ViewPage";
import EditPage from "./containers/pages/EditPage";
import AddNewsletter from "./containers/newsletters/AddNewsletter";
import AllNewsletters from "./containers/newsletters/AllNewsletters";
import ViewNewsletter from "./containers/newsletters/ViewNewsletter";
import EditNewsletter from "./containers/newsletters/EditNewsletter";
import AddProject from "./containers/projects/AddProject";
import AllProjects from "./containers/projects/AllProjects";
import ViewProject from "./containers/projects/SingleProject";
import EditProject from "./containers/projects/EditProject";
import Profile from "./containers/profile/Profile";
import AddBanner from "./containers/banners/AddBanner";
import AllBanners from "./containers/banners/AllBanners";
import ViewBanner from "./containers/banners/ViewBanner";
import EditBanner from "./containers/banners/EditBanner";
import AddMobilebanner from "./containers/mobilebanners/AddMobilebanner";
import AllMobilebanners from "./containers/mobilebanners/AllMobilebanners";
import ViewMobilebanner from "./containers/mobilebanners/ViewMobilebanner";
import EditMobilebanner from "./containers/mobilebanners/EditMobilebanner";
import AddTestimonial from "./containers/testimonials/AddTestimonial";
import AllTestimonials from "./containers/testimonials/AllTestimonials";
import ViewTestimonial from "./containers/testimonials/ViewTestimonial";
import EditTestimonial from "./containers/testimonials/EditTestimonial";
import AddFaq from "./containers/faqs/AddFaq";
import AllFaqs from "./containers/faqs/AllFaqs";
import ViewFaq from "./containers/faqs/ViewFaq";
import EditFaq from "./containers/faqs/EditFaq";
import AddContact from "./containers/contacts/AddContact";
import AllContacts from "./containers/contacts/AllContacts";
import ViewContact from "./containers/contacts/ViewContact";
import EditContact from "./containers/contacts/EditContact";
import AddDonation from "./containers/donations/AddDonation";
import AllDonations from "./containers/donations/AllDonations";
import ViewDonation from "./containers/donations/ViewDonation";
import EditDonation from "./containers/donations/EditDonation";
import AddCause from "./containers/causes/AddCause";
import AllCauses from "./containers/causes/AllCauses";
import ViewCause from "./containers/causes/ViewCause";
import EditCause from "./containers/causes/EditCause";

import AddProduct from "./containers/products/AddProduct";
import AllProducts from "./containers/products/AllProducts";
import ViewProduct from "./containers/products/ViewProduct";
import EditProduct from "./containers/products/EditProduct";

import AddVolunteer from "./containers/volunteers/AddVolunteer";
import AllVolunteers from "./containers/volunteers/AllVolunteers";
import ViewVolunteer from "./containers/volunteers/ViewVolunteer";
import EditVolunteer from "./containers/volunteers/EditVolunteer";

import AddWish from "./containers/wishes/AddWish";
import AllWishs from "./containers/wishes/AllWishs";
import ViewWish from "./containers/wishes/ViewWish";
import EditWish from "./containers/wishes/EditWish";

import AddScriberequest from "./containers/scriberequests/AddScriberequest";
import AllScriberequests from "./containers/scriberequests/AllScriberequest";
import ViewScriberequest from "./containers/scriberequests/ViewScriberequest";
import EditScriberequest from "./containers/scriberequests/EditScriberequest";

import AddVolunteerrequest from "./containers/volunteerrequests/AddVolunteerrequest";
import AllVolunteerrequests from "./containers/volunteerrequests/AllVolunteerrequests";
import ViewVolunteerrequest from "./containers/volunteerrequests/ViewVolunteerrequest";
import EditVolunteerrequest from "./containers/volunteerrequests/EditVolunteerrequest";

import AddBenificiary from "./containers/benificiarys/AddBenificiary";
import AllBenificiarys from "./containers/benificiarys/AllBenificiarys";
import ViewBenificiary from "./containers/benificiarys/ViewBenificiary";
import EditBenificiary from "./containers/benificiarys/EditBenificiary";

import AddAid from "./containers/aids/AddAid";
import AllAids from "./containers/aids/AllAids";
import ViewAid from "./containers/aids/ViewAid";
import EditAid from "./containers/aids/EditAid";

function App() {
  useEffect(() => {
    store.dispatch(loadUser());
  }, []);

  return (
    <Provider store={store}>
      <Router>
        <Switch>
          <BeforeLoginRoutes exact path="/" component={Login} />
          <PrivateRoutes exact path="/dashboard" component={Dashboard} />
          <PrivateRoutes exact path="/profile" component={Profile} />
          <PrivateRoutes exact path="/blogs" component={AllBlogs} />
          <PrivateRoutes exact path="/blogs/add" component={AddBlog} />
          <PrivateRoutes exact path="/blogs/:id/view" component={ViewBlog} />
          <PrivateRoutes exact path="/blogs/:id/edit" component={EditBlog} />
          <PrivateRoutes exact path="/pages" component={AllPages} />
          <PrivateRoutes exact path="/pages/add" component={AddPage} />
          <PrivateRoutes exact path="/pages/:id/view" component={ViewPage} />
          <PrivateRoutes exact path="/pages/:id/edit" component={EditPage} />
          <PrivateRoutes exact path="/newsletters" component={AllNewsletters} />
          <PrivateRoutes
            exact
            path="/newsletters/add"
            component={AddNewsletter}
          />
          <PrivateRoutes
            exact
            path="/newsletters/:id/view"
            component={ViewNewsletter}
          />
          <PrivateRoutes
            exact
            path="/newsletters/:id/edit"
            component={EditNewsletter}
          />
          <PrivateRoutes exact path="/projects" component={AllProjects} />
          <PrivateRoutes exact path="/projects/add" component={AddProject} />
          <PrivateRoutes
            exact
            path="/projects/:id/view"
            component={ViewProject}
          />
          <PrivateRoutes
            exact
            path="/projects/:id/edit"
            component={EditProject}
          />
          <PrivateRoutes exact path="/banners" component={AllBanners} />
          <PrivateRoutes exact path="/banners/add" component={AddBanner} />
          <PrivateRoutes
            exact
            path="/banners/:id/view"
            component={ViewBanner}
          />
          <PrivateRoutes
            exact
            path="/banners/:id/edit"
            component={EditBanner}
          />
          <PrivateRoutes
            exact
            path="/mobilebanners"
            component={AllMobilebanners}
          />
          <PrivateRoutes
            exact
            path="/mobilebanners/add"
            component={AddMobilebanner}
          />
          <PrivateRoutes
            exact
            path="/mobilebanners/:id/view"
            component={ViewMobilebanner}
          />
          <PrivateRoutes
            exact
            path="/mobilebanners/:id/edit"
            component={EditMobilebanner}
          />
          <PrivateRoutes
            exact
            path="/testimonials"
            component={AllTestimonials}
          />
          <PrivateRoutes
            exact
            path="/testimonials/add"
            component={AddTestimonial}
          />
          <PrivateRoutes
            exact
            path="/testimonials/:id/view"
            component={ViewTestimonial}
          />
          <PrivateRoutes
            exact
            path="/testimonials/:id/edit"
            component={EditTestimonial}
          />
          <PrivateRoutes exact path="/faqs" component={AllFaqs} />
          <PrivateRoutes exact path="/faqs/add" component={AddFaq} />
          <PrivateRoutes exact path="/faqs/:id/view" component={ViewFaq} />
          <PrivateRoutes exact path="/faqs/:id/edit" component={EditFaq} />
          <PrivateRoutes exact path="/contacts" component={AllContacts} />
          <PrivateRoutes exact path="/contacts/add" component={AddContact} />
          <PrivateRoutes
            exact
            path="/contacts/:id/view"
            component={ViewContact}
          />
          <PrivateRoutes
            exact
            path="/contacts/:id/edit"
            component={EditContact}
          />
          <PrivateRoutes exact path="/donations" component={AllDonations} />
          <PrivateRoutes exact path="/donations/add" component={AddDonation} />
          <PrivateRoutes
            exact
            path="/donations/:id/view"
            component={ViewDonation}
          />
          <PrivateRoutes
            exact
            path="/donations/:id/edit"
            component={EditDonation}
          />
          <PrivateRoutes exact path="/causes" component={AllCauses} />
          <PrivateRoutes exact path="/causes/add" component={AddCause} />
          <PrivateRoutes exact path="/causes/:id/view" component={ViewCause} />
          <PrivateRoutes exact path="/causes/:id/edit" component={EditCause} />
          <PrivateRoutes exact path="/products" component={AllProducts} />
          <PrivateRoutes exact path="/products/add" component={AddProduct} />
          <PrivateRoutes
            exact
            path="/products/:id/view"
            component={ViewProduct}
          />
          <PrivateRoutes
            exact
            path="/products/:id/edit"
            component={EditProduct}
          />
          <PrivateRoutes exact path="/volunteers" component={AllVolunteers} />
          <PrivateRoutes
            exact
            path="/volunteers/add"
            component={AddVolunteer}
          />
          <PrivateRoutes
            exact
            path="/volunteers/:id/view"
            component={ViewVolunteer}
          />
          <PrivateRoutes
            exact
            path="/volunteers/:id/edit"
            component={EditVolunteer}
          />
          <PrivateRoutes exact path="/wishs" component={AllWishs} />
          <PrivateRoutes exact path="/wishs/add" component={AddWish} />
          <PrivateRoutes exact path="/wishs/:id/view" component={ViewWish} />
          <PrivateRoutes exact path="/wishs/:id/edit" component={EditWish} />

          <PrivateRoutes
            exact
            path="/scriberequests"
            component={AllScriberequests}
          />
          <PrivateRoutes
            exact
            path="/scriberequests/add"
            component={AddScriberequest}
          />
          <PrivateRoutes
            exact
            path="/scriberequests/:id/view"
            component={ViewScriberequest}
          />
          <PrivateRoutes
            exact
            path="/scriberequests/:id/edit"
            component={EditScriberequest}
          />

          <PrivateRoutes
            exact
            path="/volunteerrequests"
            component={AllVolunteerrequests}
          />
          <PrivateRoutes
            exact
            path="/volunteerrequests/add"
            component={AddVolunteerrequest}
          />
          <PrivateRoutes
            exact
            path="/volunteerrequests/:id/view"
            component={ViewVolunteerrequest}
          />
          <PrivateRoutes
            exact
            path="/volunteerrequests/:id/edit"
            component={EditVolunteerrequest}
          />
          <PrivateRoutes
            exact
            path="/benificiarys"
            component={AllBenificiarys}
          />
          <PrivateRoutes
            exact
            path="/benificiarys/add"
            component={AddBenificiary}
          />
          <PrivateRoutes
            exact
            path="/benificiarys/:id/view"
            component={ViewBenificiary}
          />
          <PrivateRoutes
            exact
            path="/benificiarys/:id/edit"
            component={EditBenificiary}
          />
          <PrivateRoutes exact path="/aids" component={AllAids} />
          <PrivateRoutes exact path="/aids/add" component={AddAid} />
          <PrivateRoutes exact path="/aids/:id/view" component={ViewAid} />
          <PrivateRoutes exact path="/aids/:id/edit" component={EditAid} />
        </Switch>
      </Router>
    </Provider>
  );
}

export default App;
